import React from 'react';
import styles from '../../../PopUp/pop-up.module.scss'
import CTARed from 'components/CTARed';
import { useState } from 'react';


const CancelOrder = ({
    setShowModal,
    suppliuer,
    date,
    onClick

}) => {

    const [isLoading, setIsloading] = useState(false)
    const [reason, setReason] = useState('')

    const handleSubmit = () => {
        if (!reason.trim()) return;
        setIsloading(true)
        onClick(reason.trim())
        setTimeout(() => {
            setShowModal(false)
            setIsloading(false)
        }, 500);
    }


    return (
        <div className={styles.content}>
            <h1 className={styles.title}>Cancelar Orden</h1>
            <h2 className={styles.subtitle}> Desea cancelar la orden de <span className={styles.span} > {`${suppliuer}`} </span>  para el <span className={styles.span} > {`${date}? `} </span>   </h2>

            <div>
                <p style={{ fontWeight: 700, color: '#666666', fontSize: 14, marginBottom: 6 }}>Motivo de cancelación <span style={{ color: '#E74C3C' }}>*</span></p>
                <textarea
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Ingresa el motivo de la cancelación..."
                    rows={4}
                    style={{
                        border: '2px solid #E9E7E2',
                        borderRadius: 6,
                        padding: '12px 16px',
                        width: '100%',
                        fontSize: 14,
                        resize: 'none',
                        fontFamily: 'inherit',
                        outline: 'none',
                        boxSizing: 'border-box',
                    }}
                />
            </div>

            <div className={styles.bottomContainer}>
                <CTARed
                    isDisabled={isLoading || !reason.trim()}
                    text="Confirmar"
                    onClick={handleSubmit}
                />
            </div>
        </div>
    );
};



export default CancelOrder;
